import { ReactNode } from 'react';
import {
  BenefitInfoTextExtensionInterface,
  BenefitInfoTextProps,
  BenefitLinkProps,
  BenefitSpecialLinkProps,
} from '../../../../extension/interface/benefit-info-text.extension.interface';

export class WellpassBenefitInfoTextExtension extends BenefitInfoTextExtensionInterface {
  getBenefitLinks(): BenefitLinkProps | undefined {
    return undefined;
  }

  getBenefitMoreLinks(): BenefitSpecialLinkProps | undefined {
    return undefined;
  }

  getHelpCenterLink(): string | undefined {
    return 'https://support.probonio.de/hc/de/articles/35496722701202-Firmenfitness-als-Sachbezug-EGYM-Wellpass';
  }

  renderAdditionalContent(_props: BenefitInfoTextProps): ReactNode {
    return null;
  }
}
